import dynamic from 'next/dynamic';

const CeQualifio = dynamic(
  () => import('@vgn-medien-holding/vgn-fe-components').then((module) => module.ContentElementQualifio),
  { ssr: false },
);

export default function ContentElementQualifio(element) {
  return <CeQualifio element={element} />;
}
